<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  //--------------- PDP Sale Counter ----------------------

  // Wait for the DOM to be fully loaded
  document.addEventListener("DOMContentLoaded", function() {
    // Check if the countdown-timer element exists before running the script
    if (document.getElementById("countdown-timer")) {

    // Default duration in hours, minutes, and seconds (e.g., 3 hours)
    const defaultDuration = "03:00:00";

    // Function to get the current time from the cookie or use the default duration
    function getCountdownTime() {
      const savedTime = getCookie('countdown_time');
      if (savedTime) {
        return new Date(savedTime);
      }
      // If no cookie, set the countdown time to the default duration
      const futureTime = new Date();
      const [hours, minutes, seconds] = defaultDuration.split(':');
      futureTime.setHours(futureTime.getHours() + parseInt(hours));
      futureTime.setMinutes(futureTime.getMinutes() + parseInt(minutes));
      futureTime.setSeconds(futureTime.getSeconds() + parseInt(seconds));

      // Save the future time in the cookie
      setCookie('countdown_time', futureTime.toString(), 3); // expires in 3 days (you can adjust)

      return futureTime;
    }

    // Function to get a cookie by name
    function getCookie(name) {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    }

    // Function to set a cookie
    function setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = name + "=" + value + ";" + expires + ";path=/";
    }

    // Function to format the time to always display two digits
    function padZero(number) {
      return number < 10 ? '0' + number : number;
    }

    // Function to update the countdown timer
    function updateCountdown() {
      const endTime = getCountdownTime();
      const now = new Date();
      const timeRemaining = endTime - now;

      if (timeRemaining <= 0) {
        // Reset countdown after time has ended
        setCookie('countdown_time', '', -1); // Remove the cookie
        document.getElementById("countdown-timer").innerHTML = "Time's up!";
        return;
      }

      const hours = padZero(Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
      const minutes = padZero(Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60)));
      const seconds = padZero(Math.floor((timeRemaining % (1000 * 60)) / 1000));

      document.getElementById("countdown-timer").innerHTML = `${hours}h: ${minutes}m: ${seconds}s`;
    }

    // Update the countdown every second
    setInterval(updateCountdown, 1000);
  }

    //--------------- PDP People Bought----------------
        const randomNumber = Math.floor(Math.random() * (900 - 5 + 1)) + 5;
        const peopleBoughtElement = document.querySelector(".people_bought_main");
    
        if (peopleBoughtElement) {
          const pdp_id = peopleBoughtElement.getAttribute('product_id');
          const cookieName = `people_bought_${pdp_id}`;
          const cookieValue = getCookie(cookieName);
    
          if (cookieValue) {
            peopleBoughtElement.querySelector(".people_bought_random").innerHTML = `${cookieValue}`;
            peopleBoughtElement.style.display = 'flex';
          } else {
            peopleBoughtElement.querySelector(".people_bought_random").innerHTML = `${randomNumber}`;
            setCookie(cookieName, randomNumber, 1);
            peopleBoughtElement.style.display = 'flex';
          }
        }
        function getCookie(name) {
          const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
          return match ? match[2] : null;
        }
        function setCookie(name, value, hours) {
          const date = new Date();
          date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
          const expires = "expires=" + date.toUTCString();
          document.cookie = name + "=" + value + ";" + expires + ";path=/";
        }

      $(".pdp-accordion-header").click(function(){
        $('.pdp-accordion-header').removeClass('active_item');
        if ($(this).next(".pdp-accordion-content").is(":hidden")) {
          $(this).addClass('active_item');
        }
        $(this).next(".pdp-accordion-content").slideToggle("fast");
        $(".pdp-accordion-content").not($(this).next()).slideUp("fast");
      });


      $('.offer_info').on('click', function(e) {
        var text = $(e.target).text();
        copyToClipboard(text);
        showToaster("Code Copied!", $(this));
      });
      
      function copyToClipboard(item) {
        const x = document.createElement('TEXTAREA');
        x.value = item;
        document.body.appendChild(x);
        x.select();
        document.execCommand('copy');
        document.body.removeChild(x);
      }
      
      function showToaster(message, element) {
        // Create toaster element
        const toaster = document.createElement('div');
        
        // Add the toaster to the provided element
        element.append(toaster);
      
        toaster.classList.add('toaster');
        toaster.textContent = message;
        
        // Style the toaster
        toaster.style.position = 'absolute';
        toaster.style.bottom = '20px';
        toaster.style.left = '50%';
        toaster.style.transform = 'translateX(-50%)';
        toaster.style.backgroundColor = '#333';
        toaster.style.color = '#fff';
        toaster.style.padding = '10px';
        toaster.style.borderRadius = '5px';
        toaster.style.fontSize = '14px';
        toaster.style.zIndex = '1000';
        toaster.style.opacity = '0';
        toaster.style.transition = 'opacity 0.5s';
      
        // Show toaster with fade-in effect
        setTimeout(() => {
          toaster.style.opacity = '1';
        }, 100);
      
        // Remove toaster after 2 seconds
        setTimeout(() => {
          toaster.style.opacity = '0';
          setTimeout(() => {
            document.body.removeChild(toaster);
          }, 500);
        }, 2000);
      }

    
  });
